import _ from 'lodash';

/**
 *
 * function evaluates the given condition, if it evaluates to true, the question needs to be rendered.
 * if condition is undefined, it is assumed that question is to be rendered unconditionally.
 *
 * @param condition
 * @param formValues
 * @returns {boolean|boolean|*|boolean}
 */
export function evaluateCondition(condition, formValues) {
    // if condition is undefined  or null,
    // return true.
    if (condition === undefined || condition === null) {
        return true;
    }

    // if condition is not an array of size 3
    if (condition.constructor !== Array) {
        // if condition is not an array, convert it to array assuming it is json string.
        // eslint-disable-next-line no-param-reassign
        condition = JSON.parse(condition);
    }

    if (!(condition.constructor === Array && condition.length === 3)) {
        throw new Error('Unsupported condition object');
    }

    const obj1 = condition[0];
    const obj2 = condition[1];
    const comparator = condition[2];

    if (comparator === 'EQ') {
        return _.get(formValues, `application.oqs.${obj1}`) === obj2;
    }
    if (comparator === 'NEQ') {
        const value = _.get(formValues, `application.oqs.${obj1}`);
        return value !== undefined ? value !== obj2 : false;
    }
    if (comparator === 'AND') {
        return (
            evaluateCondition(obj1, formValues) &&
            evaluateCondition(obj2, formValues)
        );
    }
    if (comparator === 'OR') {
        return (
            evaluateCondition(obj1, formValues) ||
            evaluateCondition(obj2, formValues)
        );
    }

    return true;
}
